/**
 * ProfessocialPost unterscheidet die Templates und stellt alle Module dafür bereit
 */

import React from 'react'
import {
  PostTypeEnum,
  ViewEnum,
  PostingTemplate, ScreenEnum,
} from '@professocial/professocialTypes/types/commonTypes'
import { InstagramPost, NetworkType } from '@3m5/sm_publish-frontend-api'

import InstagramOverview from './InstagramOverview'
import InstagramPreview from './InstagramPreview'
import { EUserRole } from '@professocialApi/professocial-core-frontend-api'

export interface IInstagramPostProps {
  post: InstagramPost | PostingTemplate | undefined
  networkPageId?: string
  width?: number
  userRole?: EUserRole
  view?: ViewEnum
  postType?: PostTypeEnum
  size?: ScreenEnum
  networkType?: NetworkType
}

const InstagramPostTemplate: React.FC<IInstagramPostProps> = (props: IInstagramPostProps) => {
  let postType = PostTypeEnum.MESSAGE
  if (Array.isArray(props.post?.content) ? props.post?.content[0].image : props.post?.content.image) postType = PostTypeEnum.PHOTO
  if (Array.isArray(props.post?.content) ? props.post?.content[0].video : props.post?.content.video) postType = PostTypeEnum.VIDEO
  if (Array.isArray(props.post?.content) ? props.post?.content[0].link : props.post?.content.link) postType = PostTypeEnum.LINK

  const showTemplate = () => {
    switch (props.view) {
    case ViewEnum.overview:
      return (
        <InstagramOverview
          userRole={props.userRole}
          postType={postType}
          view={props.view}
          size={props.size}
          width={props.width}
          networkPageId={props.networkPageId}
          post={props.post}
          networkType={NetworkType.Instagram}
        />)
    case ViewEnum.preview:
      return (
        <InstagramPreview
          userRole={props.userRole}
          postType={postType}
          view={props.view}
          size={props.size}
          networkPageId={props.networkPageId}
          post={props.post}
          networkType={NetworkType.Instagram}
        />)
    }
  }

  return (
    <>
      {showTemplate()}
    </>
  )
}
export default InstagramPostTemplate
